/**
 * @generated SignedSource<<78dab02e7f2df0246085294c716eab7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleSectionHeaderSummary_teamSchedule$data = {
  readonly events: ReadonlyArray<{
    readonly __typename: "RoutineOccasion";
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleSectionHeaderSummaryOccasions_teamSchedule">;
  } | {
    readonly __typename: "TeamScheduleInlineRoutineOccasion";
    readonly taskExecution: {
      readonly routineOccasion: {
        readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleSectionHeaderSummaryOccasions_teamSchedule">;
      };
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  }>;
  readonly id: string;
  readonly " $fragmentType": "TeamScheduleSectionHeaderSummary_teamSchedule";
};
export type TeamScheduleSectionHeaderSummary_teamSchedule$key = {
  readonly " $data"?: TeamScheduleSectionHeaderSummary_teamSchedule$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleSectionHeaderSummary_teamSchedule">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TeamScheduleSectionHeaderSummaryOccasions_teamSchedule"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleSectionHeaderSummary_teamSchedule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includeInlineRoutines",
          "value": true
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "events",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "type": "RoutineOccasion",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "TaskExecutionCheck",
              "kind": "LinkedField",
              "name": "taskExecution",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RoutineOccasion",
                  "kind": "LinkedField",
                  "name": "routineOccasion",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "TeamScheduleInlineRoutineOccasion",
          "abstractKey": null
        }
      ],
      "storageKey": "events(includeInlineRoutines:true)"
    }
  ],
  "type": "TeamSchedule",
  "abstractKey": null
};
})();

(node as any).hash = "8d33387425eac180fbf4f1612c616e4b";

export default node;
